import { render } from "./ApiUnavailable.vue?vue&type=template&id=08354506"
const script = {}

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ApiUnavailable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08354506"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08354506', __exports__)) {
    api.reload('08354506', __exports__)
  }
  
  module.hot.accept("./ApiUnavailable.vue?vue&type=template&id=08354506", () => {
    api.rerender('08354506', render)
  })

}


export default __exports__